// pageScaleDisabled 禁止页面缩放

// 禁止双指放大
document.documentElement.addEventListener('touchstart', function(event) {
    if (event.touches.length > 1) {
        event.preventDefault();
    }
}, false);

// 禁止双击放大
let lastTouchEndTime = 0;
document.documentElement.addEventListener('touchend', function(event) {
    const now = Date.now();
    if (now - lastTouchEndTime <= 300) {
        event.preventDefault();
    }
    lastTouchEndTime = now;
}, false);